import React from 'react';
import { Input } from 'reactstrap';

class NumberInput extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            val: this.props.value,
            focus: false
        };
    }

    rejectNonNumericInput(e) {
        const re = /[0-9-.]+/g;
        if (!re.test(e.key)) {
            e.preventDefault();
        }
    }

    onChange = (e) => {
        this.setState({
            val: e.target.value
        })
        this.props.onChange(e);
    }

    render = () => {
        const val = (parseFloat(this.state.val) !== parseFloat(this.props.value)) ? this.props.value : this.state.val;
        return (
            <div>
                {val !== 0 && this.state.focus ? <div className="formatCurrency">{this.props.type === 'currency' ? '$' : ''}{new Intl.NumberFormat().format(val)}</div> : null}
                <Input
                    type={this.state.focus ? "text" : "text"}
                    name={this.props.name}
                    value={this.state.focus ? val : ((val !== 0 && val !== '') ? (this.props.type === 'currency' ? "$" + new Intl.NumberFormat().format(val) : new Intl.NumberFormat().format(val)) : "")}
                    onBlur={(e) => {
                        this.props.onBlur(e);
                        this.setState({ focus: false });
                    }}
                    onFocus={() => this.setState({ focus: true })}
                    onKeyPress={(e) => this.rejectNonNumericInput(e)}
                    onChange={this.onChange}
                    tabIndex={this.props.tabIndex}
                    innerRef={this.props.innerRef}
                    disabled={this.props.disabled}
                    placeholder={this.props.placeholder}
                ></Input>
            </div>
        )
    }
}

export default NumberInput;